import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=504cda4c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504cda4c')) {
      api.createRecord('504cda4c', component.options)
    } else {
      api.reload('504cda4c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=504cda4c&", function () {
      api.rerender('504cda4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gnBZojaBZHuV/JS/comp/ImgFallback.vue"
export default component.exports